import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from 'Components';
import './MobileList.css';


const MobileList = ({
  data,
  title,
  icon,
  onClick,
}) => (
  <div className="mobile-list">
    {title && <h4 className="mobile-list__title">{title}</h4>}
    {
      data.map((item, i) =>
      (
        <Button key={i} className="mobile-list__col" onClick={e => onClick(e, i)}> { /* eslint-disable-line */}
          <span>
            {item}
          </span>
          <Icon icon={icon} />
        </Button>
      ))
    }
  </div>
);

MobileList.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.string),
};

export default MobileList;



// WEBPACK FOOTER //
// ./src/components/MobileList/MobileList.jsx